import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store";
import { getPrimaryShopId } from "../../helpers/shop";
import { clearShopWifiState } from "../../slices/ShopWifi/reducer";
import { getWifiInfo, updateWifiInfo } from "../../slices/ShopWifi/thunk";
import ConfirmModal from "../../Components/Common/ConfirmModal";
import HeaderSidebarToggle from "../../Components/Common/HeaderSidebarToggle";
import HomeLogoLink from "../../Components/Common/HomeLogoLink";

const WifiPage = () => {
    const dispatch = useDispatch<AppDispatch>();
    const authUser = useSelector((state: any) => state.auth?.user);
    const { shop, loading, error, updating, updateError, updateSuccess } = useSelector((state: any) => state.ShopWifi);
    const shopId = useMemo(() => getPrimaryShopId(authUser), [authUser]);

    const [formState, setFormState] = useState({
        wifi_name: "",
        wifi_password: "",
    });
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    useEffect(() => {
        if (shopId) {
            dispatch(getWifiInfo(shopId));
        }
    }, [dispatch, shopId]);

    useEffect(() => {
        if (shop) {
            setFormState({
                wifi_name: shop?.wifi_name ?? "",
                wifi_password: shop?.wifi_password ?? "",
            });
        }
    }, [shop]);

    useEffect(() => {
        if (updateSuccess) {
            dispatch(clearShopWifiState());
        }
    }, [dispatch, updateSuccess]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormState((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsConfirmOpen(true);
    };

    const handleConfirmUpdate = () => {
        if (!shopId) {
            setIsConfirmOpen(false);
            return;
        }

        const payload = new FormData();
        payload.append("name", shop?.name ?? "");
        payload.append("phone", shop?.phone ?? "");
        payload.append("address", shop?.address ?? "");
        payload.append("tone_color", shop?.tone_color ?? "#2563EB");
        payload.append("latitude", shop?.latitude?.toString() ?? "");
        payload.append("longitude", shop?.longitude?.toString() ?? "");
        payload.append("altitude", shop?.altitude?.toString() ?? "");
        payload.append("wifi_name", formState.wifi_name);
        payload.append("wifi_password", formState.wifi_password);

        dispatch(updateWifiInfo({ shopId, data: payload }));
        setIsConfirmOpen(false);
    };

    return (
        <React.Fragment>
            <div className="header-area" id="headerArea">
                <div className="container h-100 d-flex align-items-center justify-content-between rtl-flex-d-row-r">
                    <HomeLogoLink className="me-2" />
                    <div className="page-heading">
                        <h6 className="mb-0">Wi-Fi quán</h6>
                    </div>
                    <HeaderSidebarToggle className="ms-2" />
                </div>
            </div>

            <div className="page-content-wrapper">
                <div className="container">
                    <div className="profile-wrapper-area py-3">
                        <div className="card user-data-card">
                            <div className="card-body">
                                {loading && <p className="text-center mb-3">Đang tải thông tin Wi-Fi...</p>}
                                {error && <p className="text-danger mb-3 text-center">{error}</p>}
                                {updateError && <p className="text-danger mb-3 text-center">{updateError}</p>}
                                {updateSuccess && <p className="text-success mb-3 text-center">Đã cập nhật thông tin Wi-Fi.</p>}

                                <form onSubmit={handleSubmit}>
                                    <div className="single-profile-data d-flex align-items-center justify-content-between">
                                        <div className="title d-flex align-items-center">
                                            <i className="mdi mdi-wifi"></i>
                                            <span>Tên Wi-Fi đang chia sẻ</span>
                                        </div>
                                        <div className="data-content">{shop?.wifi_name || "--"}</div>
                                    </div>
                                    <div className="single-profile-data d-flex align-items-center justify-content-between mb-3">
                                        <div className="title d-flex align-items-center">
                                            <i className="mdi mdi-lock-outline"></i>
                                            <span>Mật khẩu đang chia sẻ</span>
                                        </div>
                                        <div className="data-content">{shop?.wifi_password || "--"}</div>
                                    </div>

                                    <div className="mb-3">
                                        <div className="title mb-2">
                                            <i className="mdi mdi-wifi"></i>
                                            <span>Tên Wi-Fi</span>
                                        </div>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="wifi_name"
                                            value={formState.wifi_name}
                                            onChange={handleChange}
                                            placeholder="Nhập tên Wi-Fi"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <div className="title mb-2">
                                            <i className="mdi mdi-lock-outline"></i>
                                            <span>Mật khẩu Wi-Fi</span>
                                        </div>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="wifi_password"
                                            value={formState.wifi_password}
                                            onChange={handleChange}
                                            placeholder="Nhập mật khẩu Wi-Fi"
                                        />
                                    </div>

                                    <button className="btn btn-primary btn-lg w-100" type="submit" disabled={updating || loading}>
                                        {updating ? "Đang cập nhật..." : "Cập nhật"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ConfirmModal
                isOpen={isConfirmOpen}
                typeConfirm="primary"
                title="Xác nhận cập nhật"
                content="Bạn có chắc chắn muốn cập nhật thông tin Wi-Fi?"
                onConfirm={handleConfirmUpdate}
                onCancel={() => setIsConfirmOpen(false)}
            />
        </React.Fragment>
    );
};

export default WifiPage;
